// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.nav-link-text{
    background-color: transparent !important;
    font-size: 14px !important;
}

.nav-item {
    margin-left: 0 !important;
    padding-left: 0rem !important;
}

.nav {
    width: 100% !important;
}

.collapse.show {
    justify-content: left !important;
}
.sidebar-icon-img {
    width: 25px;
    height: auto;      /* keeps aspect ratio */
    cursor: pointer;
}

.main-links-section {
  display: flex;
  width: 100%;
}

.navigation-rail {
    margin-left: 0.3rem;
    width: 15px;          /* or 72px / 80px */
    flex-shrink: 0;       /* prevent shrinking */
}

.home .nav-link-text {
    margin-left: 16px;
}

/* Default state (visible) - delay appearance until submenu closes */
.module-name {
    margin-left: 20px;
    opacity: 1;
    transform: translateX(0);
    pointer-events: auto;
    transition: opacity 0.25s ease-in-out 0.3s, transform 0.25s ease-in-out 0.3s;
}

/* Active/hidden state - hide immediately with no delay */
.module-name.active-submenu {
    opacity: 0;
    transform: translateX(-20px);
    pointer-events: none;
    transition: opacity 0.25s ease-in-out 0s, transform 0.25s ease-in-out 0s;
}

/* Sub-menu starts hidden */
.collapse.show.sidebar * { /* smt w collapse show*/
    padding-left: 0px;
}

.sub-menu {
    opacity: 0;
    transform: translateX(-20px);
    max-width: 200px !important;
    overflow: hidden;
    transition: 
        opacity 0.3s ease-in-out,
        transform 0.3s ease-in-out,
        max-width 0.3s ease-in-out;
}

/* When active, sub-menu appears */
.sub-menu.hucs,
.sub-menu.hrms,
.sub-menu.mdm {  
    width: 200px; 
    opacity: 1;
    transform: translateX(0);
}

.icon-highlight.nav-link {
    cursor: pointer;
    padding-right: 0.2rem !important;
}

.hrms.icon-highlight.active-submenu::before {
    content: '';
    position: absolute;
    bottom: -4px;
    right: 0;
    width: 5px;
    height: 20px;
    background-color: inherit;
    border-radius: 0px 0 0 10px;
    /*z-index: 1;*/
}

.hucs.icon-highlight.active-submenu::before {
    content: '';
    position: absolute;
    bottom: -4px;
    right: 0;
    width: 5px;
    height: 43px;
    background-color: inherit;
    border-radius: 10px 0 0 10px;
    /*z-index: 1;*/
}

.icon-highlight {
    border-radius: 10px 0 0 10px !important;
    position: relative;
}

.icon-highlight::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0%;
    height: 100%;
    background-color: #A11002;
    transition: width 0.4s ease;
    /*z-index: 0;*/
}

.icon-highlight.hrms {
    background-color: #D06C01 !important;
}

.icon-highlight.hucs {
    width: 100%;
}

.icon-highlight.mdm {
    background-color: #146F06 !important;
}

.sub-menu.hrms {
    border-radius: 0 10px 10px 10px;
}

.sub-menu.hucs, .sub-menu.mdm {
    border-radius: 10px;
}

.husaria-sidebar ul {
  list-style: none;   /* removes bullets */
  padding: 0;
  margin: 0;
}

li {
  list-style: none;
}

.route-link.dashboard{
    margin-left: 0 !important;
}

.hucs .route-link:not(.dashboard){
    padding-left: 41px !important;
}

.hucs .devices-active {
    padding-left: 14px;
}

.hucs .devices .route-link {
    padding-left: 52px !important;
}

.closed-sidenav {
    
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/css/Sidebar.css"],"names":[],"mappings":";;AAEA;IACI,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,YAAY,OAAO,uBAAuB;IAC1C,eAAe;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;IACI,mBAAmB;IACnB,WAAW,WAAW,mBAAmB;IACzC,cAAc,QAAQ,sBAAsB;AAChD;;AAEA;IACI,iBAAiB;AACrB;;AAEA,oEAAoE;AACpE;IACI,iBAAiB;IACjB,UAAU;IACV,wBAAwB;IACxB,oBAAoB;IACpB,4EAA4E;AAChF;;AAEA,yDAAyD;AACzD;IACI,UAAU;IACV,4BAA4B;IAC5B,oBAAoB;IACpB,wEAAwE;AAC5E;;AAEA,2BAA2B;AAC3B,2BAA2B,uBAAuB;IAC9C,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;IAChB;;;kCAG8B;AAClC;;AAEA,kCAAkC;AAClC;;;IAGI,YAAY;IACZ,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE,gBAAgB,IAAI,oBAAoB;EACxC,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;AAEA","sourcesContent":["\r\n\r\n.nav-link-text{\r\n    background-color: transparent !important;\r\n    font-size: 14px !important;\r\n}\r\n\r\n.nav-item {\r\n    margin-left: 0 !important;\r\n    padding-left: 0rem !important;\r\n}\r\n\r\n.nav {\r\n    width: 100% !important;\r\n}\r\n\r\n.collapse.show {\r\n    justify-content: left !important;\r\n}\r\n.sidebar-icon-img {\r\n    width: 25px;\r\n    height: auto;      /* keeps aspect ratio */\r\n    cursor: pointer;\r\n}\r\n\r\n.main-links-section {\r\n  display: flex;\r\n  width: 100%;\r\n}\r\n\r\n.navigation-rail {\r\n    margin-left: 0.3rem;\r\n    width: 15px;          /* or 72px / 80px */\r\n    flex-shrink: 0;       /* prevent shrinking */\r\n}\r\n\r\n.home .nav-link-text {\r\n    margin-left: 16px;\r\n}\r\n\r\n/* Default state (visible) - delay appearance until submenu closes */\r\n.module-name {\r\n    margin-left: 20px;\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n    pointer-events: auto;\r\n    transition: opacity 0.25s ease-in-out 0.3s, transform 0.25s ease-in-out 0.3s;\r\n}\r\n\r\n/* Active/hidden state - hide immediately with no delay */\r\n.module-name.active-submenu {\r\n    opacity: 0;\r\n    transform: translateX(-20px);\r\n    pointer-events: none;\r\n    transition: opacity 0.25s ease-in-out 0s, transform 0.25s ease-in-out 0s;\r\n}\r\n\r\n/* Sub-menu starts hidden */\r\n.collapse.show.sidebar * { /* smt w collapse show*/\r\n    padding-left: 0px;\r\n}\r\n\r\n.sub-menu {\r\n    opacity: 0;\r\n    transform: translateX(-20px);\r\n    max-width: 200px !important;\r\n    overflow: hidden;\r\n    transition: \r\n        opacity 0.3s ease-in-out,\r\n        transform 0.3s ease-in-out,\r\n        max-width 0.3s ease-in-out;\r\n}\r\n\r\n/* When active, sub-menu appears */\r\n.sub-menu.hucs,\r\n.sub-menu.hrms,\r\n.sub-menu.mdm {  \r\n    width: 200px; \r\n    opacity: 1;\r\n    transform: translateX(0);\r\n}\r\n\r\n.icon-highlight.nav-link {\r\n    cursor: pointer;\r\n    padding-right: 0.2rem !important;\r\n}\r\n\r\n.hrms.icon-highlight.active-submenu::before {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: -4px;\r\n    right: 0;\r\n    width: 5px;\r\n    height: 20px;\r\n    background-color: inherit;\r\n    border-radius: 0px 0 0 10px;\r\n    /*z-index: 1;*/\r\n}\r\n\r\n.hucs.icon-highlight.active-submenu::before {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: -4px;\r\n    right: 0;\r\n    width: 5px;\r\n    height: 43px;\r\n    background-color: inherit;\r\n    border-radius: 10px 0 0 10px;\r\n    /*z-index: 1;*/\r\n}\r\n\r\n.icon-highlight {\r\n    border-radius: 10px 0 0 10px !important;\r\n    position: relative;\r\n}\r\n\r\n.icon-highlight::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 0%;\r\n    height: 100%;\r\n    background-color: #A11002;\r\n    transition: width 0.4s ease;\r\n    /*z-index: 0;*/\r\n}\r\n\r\n.icon-highlight.hrms {\r\n    background-color: #D06C01 !important;\r\n}\r\n\r\n.icon-highlight.hucs {\r\n    width: 100%;\r\n}\r\n\r\n.icon-highlight.mdm {\r\n    background-color: #146F06 !important;\r\n}\r\n\r\n.sub-menu.hrms {\r\n    border-radius: 0 10px 10px 10px;\r\n}\r\n\r\n.sub-menu.hucs, .sub-menu.mdm {\r\n    border-radius: 10px;\r\n}\r\n\r\n.husaria-sidebar ul {\r\n  list-style: none;   /* removes bullets */\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\nli {\r\n  list-style: none;\r\n}\r\n\r\n.route-link.dashboard{\r\n    margin-left: 0 !important;\r\n}\r\n\r\n.hucs .route-link:not(.dashboard){\r\n    padding-left: 41px !important;\r\n}\r\n\r\n.hucs .devices-active {\r\n    padding-left: 14px;\r\n}\r\n\r\n.hucs .devices .route-link {\r\n    padding-left: 52px !important;\r\n}\r\n\r\n.closed-sidenav {\r\n    \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
